export const NotFoundPage = ({ type = "page", slug }) => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "var(--ui-bg)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h1
          style={{
            fontSize: "96px",
            fontWeight: "bold",
            color: "var(--ui-text-faint)",
          }}
        >
          404
        </h1>

        {type === "company" ? (
          <>
            <h2
              style={{
                fontSize: "24px",
                fontWeight: "600",
                color: "var(--ui-text-secondary)",
                marginTop: "16px",
              }}
            >
              Company Not Found
            </h2>
            <p
              style={{
                color: "var(--ui-text-muted)",
                marginTop: "8px",
              }}
            >
              The company "{slug}" does not exist or is no longer active.
            </p>
          </>
        ) : (
          <>
            <h2
              style={{
                fontSize: "24px",
                fontWeight: "600",
                color: "var(--ui-text-secondary)",
                marginTop: "16px",
              }}
            >
              Page Not Found
            </h2>
            <p
              style={{
                color: "var(--ui-text-muted)",
                marginTop: "8px",
              }}
            >
              The page you're looking for doesn't exist.
            </p>
          </>
        )}

        <div
          style={{
            marginTop: "24px",
            display: "flex",
            gap: "16px",
            justifyContent: "center",
          }}
        >
          <a
            href="/"
            style={{
              display: "inline-block",
              padding: "12px 24px",
              backgroundColor: "var(--ui-primary)",
              color: "white",
              borderRadius: "8px",
              fontWeight: "500",
              textDecoration: "none",
            }}
          >
            Go to Homepage
          </a>
          <a
            href="/login"
            style={{
              display: "inline-block",
              padding: "12px 24px",
              border: "1px solid var(--ui-primary)",
              color: "var(--ui-primary)",
              borderRadius: "8px",
              fontWeight: "500",
              textDecoration: "none",
            }}
          >
            Sign In
          </a>
        </div>
      </div>
    </div>
  );
};
